/// <amd-module name="VSS/Platform/RestClient/Authentication" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   webplatform\web\extensions\vss-web\vss-platform\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "../Context";
import { RestClientBase } from "../RestClientBase";

import * as Authentication from "../Contracts/Authentication";

import { IAuthenticationRestClient } from "VSS/Platform/RestClient/Authentication.Types";

export { IAuthenticationRestClient } from "VSS/Platform/RestClient/Authentication.Types";

class AuthenticationRestClient extends RestClientBase implements IAuthenticationRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param sessionToken - 
     */
    public async createSessionToken(
        sessionToken: Authentication.WebSessionToken
        ): Promise<Authentication.WebSessionToken> {

        return this.beginRequest<Authentication.WebSessionToken>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/WebPlatformAuth/SessionToken",
            body: sessionToken
        });
    }

}

export const AuthenticationClientName = "IAuthenticationRestClient";

export function getAuthenticationClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IAuthenticationRestClient {
    return pageContext.getRestClient<IAuthenticationRestClient>(AuthenticationClientName, options);
}

RestClients.add(AuthenticationClientName, { 
    factory: AuthenticationRestClient
});
